"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateConnected = exports.StateConnecting = exports.StateChangeEvent = exports.TrackRemoved = exports.TrackAdded = exports.TrackChangeEvent = exports.IceCandidate = exports.Answer = exports.Offer = exports.Configuration = void 0;
const Tracks_1 = require("./Tracks");
const Listener_1 = require("./Listener");
const sdpTransform = require("sdp-transform");
const Queue_1 = require("./Queue");
const browserHelper_1 = require("./browserHelper");
/* tslint:disable:max-classes-per-file */
class RTCSessionDescriptionInitTracks {
    constructor(sdp, tracks) {
        this.sdp = sdp.sdp;
        this.type = sdp.type;
        this.tracks = tracks;
    }
}
class Configuration {
}
exports.Configuration = Configuration;
class Offer {
    constructor(sdp) {
        this.sdp = sdp;
    }
}
exports.Offer = Offer;
class Answer {
    constructor(sdp) {
        this.sdp = sdp;
    }
}
exports.Answer = Answer;
class IceCandidate {
    constructor(candidate) {
        this.candidate = candidate;
    }
}
exports.IceCandidate = IceCandidate;
class Negotiate {
}
class Connect {
    constructor(requestRemoteTracks) {
        this.requestRemoteTracks = requestRemoteTracks;
    }
}
class RestartIce {
}
class TrackChangeEvent {
}
exports.TrackChangeEvent = TrackChangeEvent;
class TrackAdded extends TrackChangeEvent {
    constructor(track, mid) {
        super();
        this.mid = mid;
        this.track = track;
    }
}
exports.TrackAdded = TrackAdded;
class TrackRemoved extends TrackChangeEvent {
    constructor(type) {
        super();
        this.type = type;
    }
}
exports.TrackRemoved = TrackRemoved;
class StateChangeEvent {
    constructor(event) {
        this.event = event;
    }
}
exports.StateChangeEvent = StateChangeEvent;
class StateConnecting extends StateChangeEvent {
}
exports.StateConnecting = StateConnecting;
class StateConnected extends StateChangeEvent {
}
exports.StateConnected = StateConnected;
class Connection extends Listener_1.default {
    constructor(signaling, configuration, sfu = false, sip = false) {
        super();
        this.sendEncodings = new Map();
        this.offeringTracks = [];
        this.signaling = signaling;
        const logger = (configuration === null || configuration === void 0 ? void 0 : configuration.logger) || console;
        const transceivers = new Map();
        const iceQueue = [];
        const receivingTracks = new Map();
        let polite = true;
        let first = true;
        let offerInterval;
        let trackDescriptions = {};
        this.logger = logger;
        const createNewTransceiverController = (transceiver, type) => {
            if (configuration === null || configuration === void 0 ? void 0 : configuration.transceiverControllerFactory) {
                return configuration.transceiverControllerFactory(transceiver, type);
            }
            return undefined;
        };
        const state = () => {
            var _a, _b, _c;
            return {
                type: !sfu ? "P2P" : (polite ? "Subscriber MS" : "Publisher MS"),
                ice: (_a = this.pc) === null || _a === void 0 ? void 0 : _a.iceConnectionState,
                signaling: (_b = this.pc) === null || _b === void 0 ? void 0 : _b.signalingState,
                transceivers: (_c = this.pc) === null || _c === void 0 ? void 0 : _c.getTransceivers().map(t => {
                    var _a, _b;
                    return ({
                        direction: t.direction,
                        codec: t.sender.getParameters().codecs && ((_a = t.sender.getParameters().codecs[0]) === null || _a === void 0 ? void 0 : _a.mimeType),
                        type: (_b = transceivers.get(t)) === null || _b === void 0 ? void 0 : _b.type,
                    });
                }),
            };
        };
        const init = () => {
            if (this.pc) {
                return;
            }
            this.pc = new RTCPeerConnection(configuration);
            this.pc.onsignalingstatechange = (event) => {
                var _a, _b, _c, _d, _e;
                logger.debug("onsignalingstatechange", (_a = this.pc) === null || _a === void 0 ? void 0 : _a.signalingState, state());
                if (((_b = this.pc) === null || _b === void 0 ? void 0 : _b.signalingState) === 'have-local-offer') {
                    const offer = (_c = this.pc) === null || _c === void 0 ? void 0 : _c.localDescription;
                    const desc = getTrackDescriptions();
                    offerInterval = setInterval(() => {
                        if (this.tasks.closed) {
                            clearInterval(offerInterval);
                            return;
                        }
                        logger.debug("offertimeout", state());
                        signaling.emit(new Offer(new RTCSessionDescriptionInitTracks(offer, desc)));
                    }, (configuration === null || configuration === void 0 ? void 0 : configuration.offerTimeoutMs) || 5000);
                }
                else if (((_d = this.pc) === null || _d === void 0 ? void 0 : _d.signalingState) === "stable") {
                    clearTimeout(offerInterval);
                    for (const ice of iceQueue) {
                        (_e = this.pc) === null || _e === void 0 ? void 0 : _e.addIceCandidate(ice.candidate);
                    }
                    iceQueue.length = 0;
                    if (sfu && polite)
                        return; // ignore for ms subscriber connection
                    this.negotiate(); // renegotiate if things changed while negotiating
                }
            };
            this.pc.onconnectionstatechange = (event) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e;
                logger.debug("onconnectionstatechange", (_a = this.pc) === null || _a === void 0 ? void 0 : _a.iceConnectionState, state());
                if (this.pc.connectionState === 'failed') {
                    this.fire(new StateConnecting(event));
                    if (!polite && !this.tasks.closed) {
                        logger.debug("restartice", state());
                        this.tasks.enqueue(new RestartIce());
                    }
                }
                else if (((_b = this.pc) === null || _b === void 0 ? void 0 : _b.connectionState) === "connecting" ||
                    ((_c = this.pc) === null || _c === void 0 ? void 0 : _c.connectionState) === "disconnected" ||
                    ((_d = this.pc) === null || _d === void 0 ? void 0 : _d.connectionState) === "new") {
                    this.fire(new StateConnecting(event));
                }
                else if (((_e = this.pc) === null || _e === void 0 ? void 0 : _e.connectionState) === 'connected') {
                    this.fire(new StateConnected(event));
                }
            });
            this.pc.ontrack = (event) => {
                const trackType = trackDescriptions[event.transceiver.mid].type;
                const track = new Tracks_1.Track(trackType, event.track, event.transceiver.mid);
                logger.log("ontrack", track);
                this.fire(new TrackAdded(track, event.transceiver.mid));
                receivingTracks.set(trackType, track);
            };
            this.pc.onicecandidate = (candidate) => {
                if (candidate.candidate) {
                    logger.log("onicecandidate", candidate.candidate);
                    signaling.emit(new IceCandidate(candidate.candidate));
                }
            };
        };
        const getTransceiver = (type) => {
            let trRet;
            let trDir = "inactive";
            transceivers.forEach((trType, tr) => {
                var _a, _b, _c, _d, _e;
                if (trType.type === type) {
                    trRet = tr;
                    const remoteOffer = sdpTransform.parse((_c = (_b = (_a = this.pc) === null || _a === void 0 ? void 0 : _a.remoteDescription) === null || _b === void 0 ? void 0 : _b.sdp) !== null && _c !== void 0 ? _c : '');
                    if (tr && remoteOffer) {
                        const remoteDirection = (_e = (_d = remoteOffer.media.find((m) => String(m.mid) === String(tr.mid))) === null || _d === void 0 ? void 0 : _d.direction) !== null && _e !== void 0 ? _e : "";
                        if (receivingTracks.has(type) && remoteDirection &&
                            ["recvonly", "inactive"].includes(remoteDirection)) {
                            receivingTracks.delete(type);
                            this.fire(new TrackRemoved(type));
                        }
                        if (remoteDirection) {
                            trDir = remoteDirection;
                            if (remoteDirection === 'recvonly') {
                                tr.direction = "sendonly";
                            }
                            else if (remoteDirection === "sendonly") {
                                tr.direction = "recvonly";
                            }
                            else {
                                tr.direction = remoteDirection;
                            }
                        }
                    }
                }
            });
            return [trRet, trDir];
        };
        const getTrackDescriptions = () => {
            trackDescriptions = {};
            transceivers.forEach((type, tr) => {
                trackDescriptions[tr.mid] = { "type": type.type };
            });
            return trackDescriptions;
        };
        const makeAndSendOffer = (iceRestart) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const offer = yield ((_a = this.pc) === null || _a === void 0 ? void 0 : _a.createOffer({ iceRestart }));
            /**
             * mediaserver initializes our connection on first offer,
             *  but if there are no local tracks it will not send an answer back
             *  hence we will not set localDescription, but we will send an empty offer to initialize connection
             */
            if (first && sfu && Object.keys(getTrackDescriptions()).length === 0) {
                signaling.emit(new Offer(new RTCSessionDescriptionInitTracks(offer, {})));
                first = false;
                return;
            }
            yield ((_b = this.pc) === null || _b === void 0 ? void 0 : _b.setLocalDescription(offer));
            signaling.emit(new Offer(new RTCSessionDescriptionInitTracks((_c = this.pc) === null || _c === void 0 ? void 0 : _c.localDescription, getTrackDescriptions())));
            first = false;
        });
        const setupTransceiver = (type, shouldReceiveType) => __awaiter(this, void 0, void 0, function* () {
            var _d, _e, _f, _g, _h, _j;
            const track = this.offeringTracks.find((tr) => tr.type === type);
            const [transceiver, remoteDirection] = getTransceiver(type);
            let localDirection = 'inactive';
            if (transceiver) {
                if (track) {
                    switch (remoteDirection) {
                        // from remote point of view
                        case 'recvonly':
                        case 'inactive':
                            localDirection = 'sendonly';
                            break;
                        case 'sendonly':
                        case 'sendrecv':
                            localDirection = 'sendrecv';
                            break;
                    }
                }
                else {
                    switch (remoteDirection) {
                        case 'recvonly':
                            localDirection = 'inactive';
                            break;
                        case 'sendonly':
                        case 'sendrecv':
                            localDirection = 'recvonly';
                            break;
                    }
                }
            }
            else {
                if (track) {
                    if (shouldReceiveType) {
                        localDirection = 'sendrecv';
                    }
                    else {
                        localDirection = 'sendonly';
                    }
                }
                else {
                    if (shouldReceiveType) {
                        localDirection = 'recvonly';
                    }
                    else {
                        localDirection = 'inactive';
                    }
                }
            }
            if (transceiver) {
                // @ts-ignore
                if (transceiver.stopped) {
                    logger.error("transceiver", state(), transceiver.mid);
                    return false;
                }
                if (track) {
                    if (transceiver.sender.track !== track.track) {
                        yield transceiver.sender.replaceTrack(track.track); // TODO handle promises
                        (_e = (_d = transceivers.get(transceiver)) === null || _d === void 0 ? void 0 : _d.controller) === null || _e === void 0 ? void 0 : _e.start();
                        if (sip) {
                            return false;
                        }
                    }
                }
                else {
                    (_g = (_f = transceivers.get(transceiver)) === null || _f === void 0 ? void 0 : _f.controller) === null || _g === void 0 ? void 0 : _g.stop();
                    if (transceiver.sender.track) {
                        yield transceiver.sender.replaceTrack(null);
                    }
                }
                if (transceiver.direction !== localDirection) {
                    transceiver.direction = localDirection;
                    return true;
                }
                return false;
            }
            else {
                const initTransceiver = {
                    direction: localDirection,
                    sendEncodings: this.sendEncodings.get(type),
                };
                if (track) {
                    const newTransceiver = (_h = this.pc) === null || _h === void 0 ? void 0 : _h.addTransceiver(track.track, initTransceiver);
                    transceivers.set(newTransceiver, {
                        type,
                        controller: createNewTransceiverController(newTransceiver, type),
                    });
                    return true;
                }
                else if (!sfu && !sip) {
                    const kind = {
                        [Tracks_1.TrackType.SCREEN]: "video",
                        [Tracks_1.TrackType.SCREENAUDIO]: "audio",
                        [Tracks_1.TrackType.VIDEO]: "video",
                        [Tracks_1.TrackType.AUDIO]: "audio",
                    }[type];
                    const newTransceiver = (_j = this.pc) === null || _j === void 0 ? void 0 : _j.addTransceiver(kind, initTransceiver);
                    transceivers.set(newTransceiver, {
                        type,
                        controller: createNewTransceiverController(newTransceiver, type),
                    });
                    return true;
                }
                return false;
            }
        });
        const negotiate = (requestRemoteTracks) => __awaiter(this, void 0, void 0, function* () {
            var _k;
            if (((_k = this.pc) === null || _k === void 0 ? void 0 : _k.signalingState) !== "stable")
                return;
            const results = [];
            for (const type of [Tracks_1.TrackType.AUDIO, Tracks_1.TrackType.VIDEO, Tracks_1.TrackType.SCREEN, Tracks_1.TrackType.SCREENAUDIO]) {
                results.push(yield setupTransceiver(type, requestRemoteTracks === null || requestRemoteTracks === void 0 ? void 0 : requestRemoteTracks.includes(type)));
            }
            if (results.includes(true) || first) {
                yield makeAndSendOffer();
            }
        });
        const restartice = () => __awaiter(this, void 0, void 0, function* () {
            yield makeAndSendOffer(true);
        });
        const onoffer = (offer) => __awaiter(this, void 0, void 0, function* () {
            var _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            init();
            first = false;
            trackDescriptions = offer.sdp.tracks || {
                "0": { "type": Tracks_1.TrackType.AUDIO },
                "1": { "type": Tracks_1.TrackType.VIDEO },
                "2": { "type": Tracks_1.TrackType.SCREEN },
                "3": { "type": Tracks_1.TrackType.SCREENAUDIO },
            };
            if (((_l = this.pc) === null || _l === void 0 ? void 0 : _l.signalingState) !== "stable") {
                if (!polite)
                    return;
                clearInterval(offerInterval);
                try {
                    yield ((_m = this.pc) === null || _m === void 0 ? void 0 : _m.setLocalDescription({ type: "rollback", sdp: "" }));
                }
                catch (err) {
                    // safari does not support rollback, when it does above code will not throw
                    if ((_o = browserHelper_1.default.browser.name) === null || _o === void 0 ? void 0 : _o.includes('Safari')) {
                        // set old remote description to bring it back to stable
                        yield ((_p = this.pc) === null || _p === void 0 ? void 0 : _p.setRemoteDescription((_q = this.pc) === null || _q === void 0 ? void 0 : _q.remoteDescription));
                    }
                    else {
                        throw err;
                    }
                }
            }
            yield ((_r = this.pc) === null || _r === void 0 ? void 0 : _r.setRemoteDescription(offer.sdp));
            (_s = this.pc) === null || _s === void 0 ? void 0 : _s.getTransceivers().forEach(tr => {
                const desc = trackDescriptions[tr.mid];
                if (desc) {
                    transceivers.set(tr, { type: desc.type });
                }
            });
            if (!sfu) {
                for (const type of [Tracks_1.TrackType.AUDIO, Tracks_1.TrackType.VIDEO, Tracks_1.TrackType.SCREEN, Tracks_1.TrackType.SCREENAUDIO]) {
                    yield setupTransceiver(type);
                }
            }
            yield ((_t = this.pc) === null || _t === void 0 ? void 0 : _t.setLocalDescription(yield ((_u = this.pc) === null || _u === void 0 ? void 0 : _u.createAnswer())));
            if (configuration === null || configuration === void 0 ? void 0 : configuration.sendIceWithSdp) {
                if (((_v = this.pc) === null || _v === void 0 ? void 0 : _v.iceGatheringState) !== "complete") {
                    yield new Promise((resolve, reject) => {
                        const timeout = setTimeout(() => resolve("timeout complete"), 2000);
                        this.pc.onicegatheringstatechange = (event) => {
                            var _a, _b;
                            this.logger.debug("onicegatheringstatechange", (_a = this.pc) === null || _a === void 0 ? void 0 : _a.iceGatheringState);
                            if (((_b = this.pc) === null || _b === void 0 ? void 0 : _b.iceGatheringState) === "complete") {
                                clearTimeout(timeout);
                                resolve("complete");
                            }
                        };
                    });
                    this.pc.onicegatheringstatechange = null;
                }
            }
            signaling.emit(new Answer((_w = this.pc) === null || _w === void 0 ? void 0 : _w.localDescription));
        });
        const onanswer = (answer) => __awaiter(this, void 0, void 0, function* () {
            var _x, _y;
            if (((_x = this.pc) === null || _x === void 0 ? void 0 : _x.signalingState) !== "have-local-offer")
                return;
            return (_y = this.pc) === null || _y === void 0 ? void 0 : _y.setRemoteDescription(answer.sdp);
        });
        const onice = (ice) => __awaiter(this, void 0, void 0, function* () {
            var _z, _0;
            if (((_z = this.pc) === null || _z === void 0 ? void 0 : _z.signalingState) !== "stable") {
                iceQueue.push(ice);
                return;
            }
            return (_0 = this.pc) === null || _0 === void 0 ? void 0 : _0.addIceCandidate(ice.candidate);
        });
        this.tasks = new Queue_1.default({
            process: (event) => __awaiter(this, void 0, void 0, function* () {
                const prevState = state();
                try {
                    switch (event.constructor) {
                        case Connect:
                            polite = false;
                            init();
                            yield negotiate(event.requestRemoteTracks);
                            break;
                        case Negotiate:
                            yield negotiate();
                            break;
                        case RestartIce:
                            yield restartice();
                            break;
                        case Offer:
                            yield onoffer(event);
                            break;
                        case Answer:
                            yield onanswer(event);
                            break;
                        case IceCandidate:
                            yield onice(event);
                            break;
                        default:
                            throw event;
                    }
                }
                catch (err) {
                    console.error(event, err, prevState, state());
                }
            }),
            aborted: (reason) => {
                var _a;
                (_a = this.pc) === null || _a === void 0 ? void 0 : _a.close();
                transceivers.forEach(desc => { var _a; return (_a = desc.controller) === null || _a === void 0 ? void 0 : _a.stop(); });
            }
        });
        signaling.on = (event) => {
            this.tasks.enqueue(event);
        };
    }
    /**
     * Will try to negotiate offeredTracks
     * if connection is not initialized it will prepare local tracks
     * if connection is initialized as is done by calling connect or from remote offer
     *   it will renegotiate
     * @param offerTracks
     * @param requestRemoteTracks
     */
    negotiate(offerTracks, requestRemoteTracks) {
        return __awaiter(this, void 0, void 0, function* () {
            if (offerTracks) {
                this.offeringTracks = offerTracks;
            }
            if (!this.pc) {
                return;
            }
            this.tasks.enqueue(new Negotiate());
        });
    }
    /**
     * Will initialize connection and generate an offer
     * Transceiver states will be defined from negotiate(offerTracks) and connect(requestRemoteTracks)
     * @param requestRemoteTracks TrackType[]
     */
    connect(requestRemoteTracks) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tasks.enqueue(new Connect(requestRemoteTracks));
        });
    }
    /**
     * Will abort internal tasks queue and close connection
     */
    close() {
        this.clear();
        this.tasks.abort("clean close");
    }
    /**
     * Check if internal tasks queue is closed
     */
    isClosed() {
        return this.tasks.closed;
    }
    /**
     * Get stats for a track or all tracks if track is null
     */
    getStats(selector) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (!this.pc) {
                    return resolve(new Map());
                }
                return resolve(this.pc.getStats(selector));
            });
        });
    }
}
exports.default = Connection;
//# sourceMappingURL=Connection.js.map